import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '../store';
import { IUserState } from '../stores/user.store';

export const actionChangePassword = 'changePassword';

export const actions: ActionTree<IUserState, RootState> = {
  async [actionChangePassword](context, { userId, oldPassword, newPassword }) {
    const payload = new FormData();
    payload.append('action', 'password');
    payload.append('id', userId);
    payload.append('old', oldPassword);
    payload.append('new', newPassword);

    const { data } = await axios.post('/save/settings', payload);
    if (data.status === 1) {
      return { success: true };
    } else {
      return { success: false, error: data.error };
    }
  },
};
